class ProductDisplay {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.prevButton = container.querySelectorAll('.mt-product-display__nav-button--prev');
    this.nextButton = container.querySelectorAll('.mt-product-display__nav-button--next');
    this.swiper = null;
    this.init();
  }

  init() {
    if (typeof Swiper === 'undefined') {
      this.loadSwiper().then(() => {
        this.initSwiper();
      });
    } else {
      this.initSwiper();
    }
  }

  loadSwiper() {
    return new Promise((resolve, reject) => {
      const swiperCSS = document.createElement('link');
      swiperCSS.rel = 'stylesheet';
      swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(swiperCSS);

      const swiperScript = document.createElement('script');
      swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      swiperScript.onload = resolve;
      swiperScript.onerror = reject;
      document.head.appendChild(swiperScript);
    });
  }

  initSwiper() {
    const swiperEl = this.container.querySelector('.mt-product-display__slider');

    // 销毁旧实例，避免重复初始化
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    const isMobile = window.innerWidth < 768;

    this.swiper = new Swiper(swiperEl, {
      // ---- 移动端默认配置 (<768px): 2列 x 2行，每页4个 ----
      slidesPerView: 2,
      spaceBetween: 8,  // 同时控制列间距和行间距
      slidesPerGroup: 2,  // Swiper Grid 模式：slidesPerGroup = slidesPerView
      speed: 600,
      grid: {
        rows: 2,
        fill: 'row'
      },
      breakpoints: {
        // ---- 平板 (768px+): 3列 1行 ----
        768: {
          slidesPerView: 3,
          spaceBetween: 5,
          slidesPerGroup: 3,
          grid: {
            rows: 1,
            fill: 'row'
          }
        },
        // ---- 桌面 (1024px+): 4列 1行 ----
        1024: {
          slidesPerView: 4,
          spaceBetween: 5,
          slidesPerGroup: 4,
          grid: {
            rows: 1,
            fill: 'row'
          }
        }
      },
      on: {
        init: (swiper) => {
          this.updateNavButtons(swiper);
        },
        slideChange: (swiper) => {
          this.updateNavButtons(swiper);
        },
        breakpoint: (swiper) => {
          this.updateNavButtons(swiper);
        }
      }
    });

    this.prevButton.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;
        this.swiper.slidePrev();
      });
    });

    this.nextButton.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;
        this.swiper.slideNext();
      });
    });
  }

  updateNavButtons(swiper) {
    this.prevButton.forEach((btn) => {
      btn.classList.toggle('is-disabled', swiper.isBeginning);
    });
    this.nextButton.forEach((btn) => {
      btn.classList.toggle('is-disabled', swiper.isEnd);
    });
  }
}

// 初始化所有实例
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mt-product-display').forEach((el) => {
    new ProductDisplay(el);
  });
});

// Shopify 主题编辑器支持
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.mt-product-display');
    if (container) {
      new ProductDisplay(container);
    }
  });
}
